define([
	"csi/view"
], function(csiView) {

	return {
		onAccessActionSetDefaultAgent(ctx, action) {
			return ctx.view.getViewNode().Agent != ctx.getNodeURL();
		},

		postActionSupplierAgent: function(ac) {
			// summary: when selecting suppliers for agent, the selected supplier rows should also be refreshed
			const view = ac.widget;
			if (view.postActionRefreshModifiedRows) {
				view.postActionRefreshModifiedRows(ac);
			} else {
				view.postActionRedrawNode(ac);
			}
		}
	};
});